document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".countdown-timer").forEach(timer => {
    const endDate = new Date(timer.dataset.endDate.replace(" ", "T"));
    const updateTimer = () => {
      const now = new Date();
      const diff = endDate - now;
      if (diff <= 0) {
        timer.textContent = "Expired";
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      timer.querySelector(".days").textContent = days.toString().padStart(2, "0");
      timer.querySelector(".hours").textContent = hours.toString().padStart(2, "0");
      timer.querySelector(".minutes").textContent = minutes.toString().padStart(2, "0");
      timer.querySelector(".seconds").textContent = seconds.toString().padStart(2, "0");
    };
    updateTimer();
    setInterval(updateTimer, 1000);
  });
});
